import client from "../helpers/Client";

export async function listForms(params = {}) {
  const { data } = await client.get("/service_forms/", { params: { page_size: 1000, ordering: "-created_at", ...params } });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function getForm(id) {
  const { data } = await client.get(`/service_forms/${id}/`);
  return data;
}

export async function addForm(payload) {
  const { data } = await client.post("/service_forms/", payload);
  return data;
}

export async function updateForm(id, payload) {
  const { data } = await client.put(`/service_forms/${id}/`, payload);
  return data;
}

export async function removeForm(id) {
  await client.delete(`/service_forms/${id}/`);
  return true;
}

export async function submitSurvey(id, survey) {
  const { data } = await client.post(`/service_forms/${id}/submit_survey/`, { survey });
  return data;
}

export async function sendServiceFormDownloadLink(id, { phone_number } = {}) {
  const { data } = await client.post(`/service_forms/${id}/send_download_link/`, { phone_number });
  return data;
}

export async function clearForms() {
  await client.delete("/service_forms/clear/");
  return true;
}

export async function listTechnicians() {
  const { data } = await client.get("/technicians/", { params: { page_size: 1000, ordering: "name" } });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function addTechnician(payload) {
  const body = typeof payload === "string" ? { name: payload } : payload;
  const { data } = await client.post("/technicians/", body);
  return data;
}

export async function updateTechnician(id, payload) {
  const body = typeof payload === "string" ? { name: payload } : payload;
  const { data } = await client.put(`/technicians/${id}/`, body);
  return data;
}

export async function removeTechnician(id) {
  await client.delete(`/technicians/${id}/`);
  return true;
}

export async function clearTechnicians() {
  await client.delete("/technicians/clear/");
  return true;
}

export async function searchCustomers(query, extra = {}) {
  const q = String(query || "").trim();
  if (q.length < 2) return [];
  const params = { page_size: 20, search: q, ...extra };
  const { data } = await client.get("/customers/", { params });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function searchUnits(query, extra = {}) {
  const q = String(query || "").trim();
  if (q.length < 2) return [];
  const params = { page_size: 20, search: q, ...extra };
  const { data } = await client.get("/units/", { params });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function searchProjects(query, extra = {}) {
  const q = String(query || "").trim();
  if (q.length < 2) return [];
  const params = { page_size: 20, search: q, ...extra };
  const { data } = await client.get("/projects/", { params });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function searchProducts(query, extra = {}) {
  const q = String(query || "").trim();
  if (q.length < 2) return [];
  const params = { page_size: 20, search: q, ...extra };
  const { data } = await client.get("/products/", { params });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function listProducts(params = {}) {
  const { data } = await client.get("/products/", { params: { page_size: 1000, ordering: "name", ...params } });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}

export async function listProductModels(params = {}) {
  const { data } = await client.get("/models/", { params: { page_size: 1000, ordering: "name", ...params } });
  const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
  return arr;
}
